import * as React from "react";
import { errorLog } from "../util/debug";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        errorLog('getDerivedStateFromError: ', error)

        return { hasError: true };
      }

    componentDidCatch(error, info) {
        errorLog('componentDidCatch: ', error)
        // window.localStorage.setItem(`${unexpectedError}__${Date.now()}`, JSON.stringify({ error, info }));
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="text-center width-full p-8">
                    An unexpected Error occurred. &nbsp;&nbsp; Please contact support.
                </div>
            )
        }
        return this.props.children;
    }
}
